import React from 'react';
import { Paper, Typography, Divider, Grid, Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import QuestionCard from './QuestionCard';

const QuestionsList = ({ questions, onEditQuestion, onDeleteQuestion, onAddQuestion }) => {
  if (questions.length === 0) {
    return (
      <Paper sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          No questions added yet
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Click the button to add the first question to this test
        </Typography>
        <Button 
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddQuestion}
        >
          Add First Question
        </Button>
      </Paper>
    );
  }

  return (
    <Paper elevation={2} sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Questions ({questions.length})
      </Typography>
      <Divider sx={{ mb: 3 }} />
      
      <Grid container spacing={2}>
        {questions.map((question) => (
          <Grid item xs={12} key={question._id}>
            <QuestionCard 
              question={question}
              onEdit={() => onEditQuestion(question)}
              onDelete={() => onDeleteQuestion(question)}
            />
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default QuestionsList;
